import cookies from "js-cookie";
const readCsrfToken = () => cookies?.get("csrf-token");
export { readCsrfToken };
